
/**
 * deposit原型
 */
 function DepositPrototype(name) {
    this.name = name
    this.proto_getName = function() {
        return this.name
    }

    this.proto_genIntegrateCashflowSupplierJsonKey = function(cashflowSupplierNum, vendor) {
        return `${this.proto_genPartitionIntegrateCashflowSupplierJsonKey_cashflowSupplierNum(cashflowSupplierNum)}_vendor=${vendor}`
    }

    this.proto_genPartitionIntegrateCashflowSupplierJsonKey_cashflowSupplierNum = function(cashflowSupplierNum) {
        return `cashflowSupplierNum=${cashflowSupplierNum}`
    }

    // 用傳入的depositItemInfoArr，歸納出相同的支付方式(金流商、電信商)
    this.proto_integrateCashflowSupplierByDepositItemInfoArr = function(depositItemInfoArr) {
        let integrateCashflowSupplierJson = {}
        // 逐一取出儲值品項資訊進行處理
        for(let i in depositItemInfoArr) {
            let depositItemInfoObj = depositItemInfoArr[i]
            let tmpIntegrateCashflowSupplierJson = {}
            for(let j in depositItemInfoObj["itemArr"]) {
                // 儲值品項
                let depositItemObj = depositItemInfoObj["itemArr"][j]
                // 透過每個儲值品項的金流商、電信商，產生一組key
                let integrateCashflowSupplierJsonKey = this.proto_genIntegrateCashflowSupplierJsonKey(depositItemObj["FK_CASHFLOW_SUPPLIER"], depositItemObj["VENDOR"])
                
                if(i==0) { // 第一組儲值品項資訊，將key直接儲存
                    tmpIntegrateCashflowSupplierJson[integrateCashflowSupplierJsonKey] = {
                        cashflowSupplierNum: depositItemObj["FK_CASHFLOW_SUPPLIER"],
                        vendor: depositItemObj["VENDOR"]
                    }
                }
                else if(integrateCashflowSupplierJson[integrateCashflowSupplierJsonKey]!=undefined) { // 非第一組儲值品項資訊，key存在才代表支付方式相同
                    tmpIntegrateCashflowSupplierJson[integrateCashflowSupplierJsonKey] = integrateCashflowSupplierJson[integrateCashflowSupplierJsonKey]
                }
            }
            integrateCashflowSupplierJson = tmpIntegrateCashflowSupplierJson
        }
        return integrateCashflowSupplierJson
    }


    // *****用call綁定此構造函數，下述所有function皆需要實作*****
    // *****用call綁定此構造函數，下述所有function皆需要實作*****
    // *****用call綁定此構造函數，下述所有function皆需要實作*****
    // *****用call綁定此構造函數，下述所有function皆需要實作*****
    // *****用call綁定此構造函數，下述所有function皆需要實作*****

    // 當玩家於畫面上選取儲值品項時，依據不同儲值類型，做不同處理
    this.selectDepositItemName = function(depositItemInfoArr, selectDepositItemInfoObj) {
        let retResult = { // 要回傳的格式
            isSuccess: false, // 過程成功/失敗
            depositItemInfoArr: [], // 選取的儲值品項資訊

            /**
             * 用儲值品項資訊統計出的支付方式(金流商、電信商)
             * 若depositItemInfoArr有兩個儲值品項資訊，每個資訊底下有兩個儲值品項
             * 則計算出能夠支付兩個儲值品項資訊的支付方式
             */
            integrateCashflowSupplierJson: {}
        }
        throw `${this.name} selectDepositItemName implement error`
    }

    // 依照玩家選擇的儲值品項資訊，依據不同儲值類型，判斷未被玩家選取的的儲值品項資訊是否要變更domCanSelect
    this.changeDepositItemInfoDomCanSeletByUserNotSelected = function(userDepositItemInfoArr, programDepositItemInfoArr, integrateCashflowSupplierJson) {
        throw `${this.name} changeDepositItemInfoDomCanSeletByUserNotSelected implement error`
    }

    // 送出訂單所需要的參數，依據不同儲值類型，回傳不同的key/value，若判斷失敗回傳空字串("")
    this.getOrderInfoByDepositItemPkArr = function(depositItemPkArr) { 
        throw `${this.name} getOrderInfoByDepositItemPkArr implement error`
    }

    // *****用call綁定此構造函數，上述所有function皆需要實作*****
    // *****用call綁定此構造函數，上述所有function皆需要實作*****
    // *****用call綁定此構造函數，上述所有function皆需要實作*****
    // *****用call綁定此構造函數，上述所有function皆需要實作*****
    // *****用call綁定此構造函數，上述所有function皆需要實作*****
}

/**
 * Currency儲值專用deposit
 * 
 * 說明:
 * Currency儲值只能勾選單一儲值品項
 */
function CurrencyDepositAdapt(name) {
    this.name = name
    DepositPrototype.call(this, this.name)


    /**
     * 當玩家於畫面上選取儲值品項時
     * 1.Currency儲值只能選取一個儲值品項，直接產生新陣列取代原本陣列
     * 2.計算出整合金流商
     * @param {*} depositItemInfoArr 
     * @param {*} selectDepositItemInfoObj 
     * @returns 
     */
    this.selectDepositItemName = function(depositItemInfoArr, selectDepositItemInfoObj) {
        // 欲回傳結果
        let retResult = {
            isSuccess: false,
            depositItemInfoArr: [selectDepositItemInfoObj], // Currency儲值只能選一個，所以新陣列直接取代掉原本的
            integrateCashflowSupplierJson: {}
        }

        // 用depositItemInfoArr，整合出支付方式(金流商、電信商)於integrateDepositItemInfoPaymentJson
        retResult["integrateCashflowSupplierJson"] = this.proto_integrateCashflowSupplierByDepositItemInfoArr(retResult.depositItemInfoArr)
        retResult["isSuccess"] = true

        return retResult
    }


    /**
     * 依照玩家選擇的儲值品項資訊，判斷未被玩家選取的的儲值品項資訊是否要變更domCanSelect
     * @param {*} userDepositItemInfoArr 
     * @param {*} programDepositItemInfoArr 
     * @param {*} integrateCashflowSupplierJson 
     */
    this.changeDepositItemInfoDomCanSeletByUserNotSelected = function(userDepositItemInfoArr, programDepositItemInfoArr, integrateCashflowSupplierJson) {
        // Currency儲值類型不需要修改
    }


    /**
     * 依據Currency儲值產生要送出訂單所需要的參數，若判斷失敗回傳空字串("")
     * @param {*} depositItemPkArr 
     * @returns 
     */
    this.getOrderInfoByDepositItemPkArr = function(depositItemPkArr) {
        if(!Array.isArray(depositItemPkArr)) {
            return ""
        }

        if(depositItemPkArr.length != 1) {
            return ""
        }

        return {
            "deposit.fkDepositItemId": depositItemPkArr[0]
        }
    }
}



/**
 * Bundle專用deposit
 * 
 * 說明:
 * 可以多選畫面上的儲值品項資訊
 */
function BundleDepositAdapt(name) {
    this.name = name
    DepositPrototype.call(this, this.name)

    
    /**
     * 當玩家於畫面上選取儲值品項時，依據下列情境做不同處理
     * 1.過去不曾選取儲值品項資訊，此次第一次選取
     * 2.過去有選取儲值品項資訊，此次選了不同儲值品項資訊
     * 3.過去有選取儲值品項資訊，此次選了相同儲值品項資訊，過去選擇的儲值品項扣除此次後還有剩
     * 4.過去有選取儲值品項資訊，此次選了相同儲值品項資訊，過去選擇的儲值品項扣除此次後沒有剩
     * @param {*} depositItemInfoArr 
     * @param {*} selectDepositItemInfoObj 
     * @returns 
     */
    this.selectDepositItemName = function(depositItemInfoArr, selectDepositItemInfoObj) {
        let retResult = { // 要回傳的格式
            isSuccess: false,
            depositItemInfoArr: [],
            integrateCashflowSupplierJson: {}
        }


        // 判斷新選擇的儲值品項資訊在過去是否有選擇過
        // 過去若選擇過，tmpDepositItemInfoArr會不包含 & isSameDepositItemInfoFlag=true
        let tmpDepositItemInfoArr = []
        let isSameDepositItemInfoFlag = false
        for(let i in depositItemInfoArr) {
            let depositItemInfoObj = depositItemInfoArr[i]
            if(depositItemInfoObj["itemName"]==selectDepositItemInfoObj["itemName"]
               && depositItemInfoObj["amount"]==selectDepositItemInfoObj["amount"]
               && depositItemInfoObj["twAmount"]==selectDepositItemInfoObj["twAmount"]) { // 新選擇的儲值品項資訊過去有選擇過
                isSameDepositItemInfoFlag = true
            }
            else { // 過去選擇的儲值品項與新選擇的不同
                tmpDepositItemInfoArr.push(depositItemInfoObj)
            }
        }

        // 依照情境不同，做不同處理
        let newDepositItemInfoArr = []
        if(true) {
            let subFlag = true
            // 1.過去不曾選取儲值品項資訊，此次第一次選取
            if(subFlag) {
                if(depositItemInfoArr.length==0 && isSameDepositItemInfoFlag==false) {
                    subFlag = false
                    newDepositItemInfoArr.push(selectDepositItemInfoObj)
                }
            }
            // 2.過去有選取儲值品項資訊，此次選了不同儲值品項資訊
            if(subFlag) {
                if(depositItemInfoArr.length>0 && isSameDepositItemInfoFlag==false) {
                    subFlag = false
                    newDepositItemInfoArr = depositItemInfoArr
                }
            }
            // 3.過去有選取儲值品項資訊，此次選了相同儲值品項資訊，過去選擇的儲值品項扣除此次後還有剩
            if(subFlag) {
                if(depositItemInfoArr.length>0 
                   && isSameDepositItemInfoFlag==true
                   && tmpDepositItemInfoArr.length>0) {
                    subFlag = false
                    newDepositItemInfoArr = tmpDepositItemInfoArr
                }
            }
            // 4.過去有選取儲值品項資訊，此次選了相同儲值品項資訊，過去選擇的儲值品項扣除此次後沒有剩
            if(subFlag) {
                if(depositItemInfoArr.length>0 
                   && isSameDepositItemInfoFlag==true
                   && tmpDepositItemInfoArr.length==0) {
                    subFlag = false
                    newDepositItemInfoArr = tmpDepositItemInfoArr
                }
            }

            // 上述情境以外，直接return
            if(subFlag) {
                return retResult
            }
        }


        // 用newDepositItemInfoArr，歸納出相同的支付方式(金流商、電信商)於integrateCashflowSupplierJson
        let integrateCashflowSupplierJson = this.proto_integrateCashflowSupplierByDepositItemInfoArr(newDepositItemInfoArr)


        // 針對「2.過去有選取儲值品項資訊，此次選了不同儲值品項資訊」進一步判斷
        // 若新選擇的儲值品項資訊的支付方式存在於integrateCashflowSupplierJson，表示可以支付
        if(depositItemInfoArr.length>0 && isSameDepositItemInfoFlag==false) {
            let tmpIntegrateCashflowSupplierJson = {}
            for(let i in selectDepositItemInfoObj["itemArr"]) {
                // 儲值品項
                let selectDepositItemObj = selectDepositItemInfoObj["itemArr"][i]
                // 儲值品項的金流商、電信商，產生一組key
                let selectCashflowSupplierJsonKey = this.proto_genIntegrateCashflowSupplierJsonKey(selectDepositItemObj["FK_CASHFLOW_SUPPLIER"], selectDepositItemObj["VENDOR"])
                // 用key檢查是否有相同的支付方式
                if(integrateCashflowSupplierJson[selectCashflowSupplierJsonKey] != undefined) {
                    tmpIntegrateCashflowSupplierJson[selectCashflowSupplierJsonKey] = integrateCashflowSupplierJson[selectCashflowSupplierJsonKey]
                }
            }

            // 新選擇儲值品項資訊的支付方式與之前歸納出的支付方式有相同
            // 則，1.採用最新歸納的、2.將新選擇的儲值品項資訊將入newDepositItemInfoArr
            if(Object.keys(tmpIntegrateCashflowSupplierJson).length > 0) {
                integrateCashflowSupplierJson = tmpIntegrateCashflowSupplierJson
                newDepositItemInfoArr.push(selectDepositItemInfoObj)
            }
        }
        

        retResult["depositItemInfoArr"] = newDepositItemInfoArr
        retResult["integrateCashflowSupplierJson"] = integrateCashflowSupplierJson
        retResult["isSuccess"] = true
        return retResult
    }


    /**
     * 判斷若未被玩家選取的的儲值品項資訊，是否要變更domCanSelect
     * 1.玩家未選擇任何一個儲值品項資訊，則所有儲值品項資訊domCanSelect=true
     * 2.玩家有選擇儲值品項資訊，則domIsSelect=false的儲值品項資訊，判斷底下的儲值品項是否可被整合金流商支付，若不行則domCanSelect=false
     * @param {*} userDepositItemInfoArr 
     * @param {*} programDepositItemInfoArr 
     * @param {*} integrateCashflowSupplierJson 
     */
    this.changeDepositItemInfoDomCanSeletByUserNotSelected = function(userDepositItemInfoArr, programDepositItemInfoArr, integrateCashflowSupplierJson) {
        if(userDepositItemInfoArr.length == 0) { // 1.玩家未選擇任何一樣儲值品項資訊
            for(let i in programDepositItemInfoArr) {
                let depositItemInfoObj = programDepositItemInfoArr[i]
                depositItemInfoObj["domCanSelect"] = true
            }
        }
        else { // 2.玩家有選擇儲值品項資訊
            // domIsSelect=false的儲值品項資訊，判斷底下的儲值品項是否可被整合金流商支付，若不行則domCanSelect=false
            for(let i in programDepositItemInfoArr) {
                let depositItmeInfoObj = programDepositItemInfoArr[i]
                if(depositItmeInfoObj["domIsSelect"] != true) {
                    // 儲值品項資訊底下是否存在某一個儲值品項是否可被整合金流商支付，若存在則matchCashflowSupplier=true
                    let matchCashflowSupplier = false
                    for(let j in depositItmeInfoObj["itemArr"]) {
                        // 用儲值品項的金流商num與電信商，組出cashflowSupplierJsonKey
                        let depositItmeObj = depositItmeInfoObj["itemArr"][j]
                        let depositItemCashflowSupplierJsonKey = this.proto_genIntegrateCashflowSupplierJsonKey(
                            depositItmeObj["FK_CASHFLOW_SUPPLIER"],
                            depositItmeObj["VENDOR"]
                        )
                        // 用depositItemCashflowSupplierJsonKey判斷是否可被支付
                        if(integrateCashflowSupplierJson[depositItemCashflowSupplierJsonKey]!=undefined) {
                            matchCashflowSupplier = true
                            break
                        }
                    }

                    // 修改儲值品項資訊的domCanSelecte
                    programDepositItemInfoArr[i]["domCanSelect"] = matchCashflowSupplier
                }
            }
        }
    }


    /**
     * 依據Bundle儲值產生要送出訂單所需要的參數，若判斷失敗回傳空字串("")
     * @param {*} depositItemPkArr 
     * @returns 
     */
    this.getOrderInfoByDepositItemPkArr = function(depositItemPkArr) {
        if(!Array.isArray(depositItemPkArr)) {
            return ""
        }

        return {
            "deposit.fkDepositItemId": 0,
            "deposit.depositItemIdList": JSON.stringify(depositItemPkArr)
        }
    }
}


export {
    CurrencyDepositAdapt,
    BundleDepositAdapt
}